import { render, staticRenderFns } from "./KnSchoolControlStudentReport.vue?vue&type=template&id=3e8c8204&scoped=true"
import script from "./KnSchoolControlStudentReport.js?vue&type=script&lang=js&external"
export * from "./KnSchoolControlStudentReport.js?vue&type=script&lang=js&external"
import style0 from "./KnSchoolControlStudentReport.vue?vue&type=style&index=0&id=3e8c8204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8c8204",
  null
  
)

export default component.exports